import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';

const ServerError = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--bg)' }}>
      <div className="text-center max-w-md">
        <div className="mb-8">
          <h1 className="text-9xl font-bold" style={{ color: 'var(--red)' }}>500</h1>
          <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text)' }}>
            Server Error
          </h2>
          <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
            Something went wrong on our end. Please try again later.
          </p>
        </div>
        
        <div className="space-y-3">
          <Button
            variant="primary"
            onClick={() => window.location.reload()}
            className="w-full"
          >
            Try Again
          </Button>
          
          <Button
            variant="secondary"
            onClick={() => navigate('/')}
            icon="home"
            className="w-full"
          >
            Go to Homepage
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
